import { useQuery, useMutation } from '@tanstack/vue-query'
import { useAuthDependencies } from '@/composables/api/auth'
import type { AxiosResponse } from 'axios'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '@/stores/auth'
import { computed } from 'vue'

export type Form = {
  url: string
  doc_type: string
  id: string
}
export type Agreement = any
export type ConsentFormResponse =
  | {
      form: Form
      agreement: Agreement
    }
  | {
      form: Form
      agreement: null
    }
  | {
      form: null
      agreement: null
    }

export const useConsentFormsQuery = () => {
  const authGetter = useAuthDependencies()
  const { data, status } = useQuery({
    queryKey: ['consentForms'],
    queryFn: async ({ signal }) => {
      const { axios } = await authGetter()
      const response = (await axios({
        method: 'get',
        url: '/api/v2/workforce_intelligence/consent_forms',
        signal
      })) as AxiosResponse<ConsentFormResponse, any>
      return response.data
    }
  })

  const formData = computed(() => {
    if (status.value === 'success' && data.value) {
      return data.value.form
    }
    return null
  })

  const agreementData = computed(() => {
    if (status.value === 'success' && data.value) {
      return data.value.agreement
    }
    return null
  })

  return {
    formData,
    agreementData,
    data,
    status
  }
}

export const useCreateConsentRecordMutation = () => {
  const authGetter = useAuthDependencies()
  const { userId } = storeToRefs(useAuthStore())

  const mutation = useMutation({
    mutationFn: async (data: any) => {
      const { axios } = await authGetter()
      return axios({
        method: 'POST',
        url: '/api/v2/workforce_intelligence/consent_forms',
        data: { ...data, user_id: userId?.value }
      }).then((data) => {
        return data.data
      })
    }
  })
  return mutation
}
